import { Header } from '../../components/Header';
import { InteractiveHero } from '../../components/InteractiveHero';
import { SEO } from '../../components/SEO';
import { getImageUrl } from '../../lib/imageUrls';

// Hero images data
const heroImages = [
  getImageUrl("/interactiveHero/image-1.jpg"),
  getImageUrl("/interactiveHero/image-2.jpg"),
  getImageUrl("/interactiveHero/image-2b.png"),
  getImageUrl("/interactiveHero/image-3.jpg"),
  getImageUrl("/interactiveHero/image-4.jpg"),
  getImageUrl("/interactiveHero/image-5.jpg"),
  getImageUrl("/interactiveHero/image-6.jpg"),
  getImageUrl("/interactiveHero/image-7.jpg"),
  getImageUrl("/interactiveHero/image-8.jpg"),
  getImageUrl("/interactiveHero/image-9.jpg"),
  getImageUrl("/interactiveHero/image-10.png")
];

export const InteractiveHeroPage = (): JSX.Element => {
  return (
    <>
      <SEO 
        title="Interactive Hero – Bes Bujupi"
        description="Interactive hero gallery showcasing creative work and visual storytelling."
      />
      
      <div className="min-h-screen bg-white dark:bg-gradient-to-br dark:from-[#0a0a0a] dark:to-[#2d2d2d]">
        {/* Background */}
        <div className="fixed inset-0 bg-white dark:bg-gradient-to-br dark:from-[#0a0a0a] dark:to-[#2d2d2d] -z-10" />
        
        <div className="relative w-full max-w-[1442px] min-h-screen px-4 lg:px-8 mx-auto">
          <Header />
          
          {/* Interactive Hero Section */}
          <div className="w-full flex justify-center items-center pt-[100px] pb-[100px]">
            <InteractiveHero images={heroImages} />
          </div>
        </div>
      </div>
    </>
  );
};
